export { ModalWidthEnum } from '@landlord-tech/ui-kit-opp';
export type {
  TModalProps,
  TModalDeleteProps,
  TModalEvent,
} from '@landlord-tech/ui-kit-opp';
